export default "__VITE_ASSET__BFZq7LDG__"